import { Box, Typography, Stack, Divider } from '@mui/material';
import { linkedInBlue, lightPurple, primaryGreen, white } from '@styles/colors';

const markers = [
  { color: linkedInBlue, label: 'Interview Confirmed', showHollow: false },
  { color: linkedInBlue, label: 'Interview Pending', showHollow: true },
  {
    color: lightPurple,
    label: 'Open Interviews - Confirmed',
    showHollow: false,
  },
  { color: lightPurple, label: 'Open Interviews - Pending', showHollow: true },
  {
    color: primaryGreen,
    label: 'Interview Block – Time Confirmed',
    showHollow: false,
  },
  { color: primaryGreen, label: 'Interview Block', showHollow: true },
];

const InterviewMarkers = () => {
  return (
    <Box bgcolor={white} borderRadius={8} sx={{ p: 3, mb: 2 }}>
      <Typography textTransform="uppercase" variant="h3">
        Interview Status
      </Typography>
      <Divider sx={{margin:'10px 0 10px 0'}}/>
      <Stack spacing={1} mt={2}>
        {markers.map((marker, index) => (
          <Box key={index} display="flex" alignItems="center" flexShrink="0">
            <Box
              sx={{
                width: 14,
                height: 14,
                borderRadius: '50%',
                backgroundColor: marker.showHollow
                  ? 'transparent'
                  : marker.color,
                border: `3px solid ${marker.color}`,
                marginRight: 1.5,
              }}
            />
            <Typography variant="body2">{marker.label}</Typography>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default InterviewMarkers;
